export default __webpack_public_path__ + "static/media/menuGold.7f62371a.svg";